import React from 'react';
import { Flower2, Star, ShieldCheck, ArrowRight, Check } from 'lucide-react';
export function Hero() {
  const benefits = ['365 days of session planning done for you', 'Professional technical & tactical progressions', 'More coaching authority, less personal stress', 'Instant digital access'];
  return <section className="relative bg-gradient-to-b from-pilates-soft to-pilates-cream overflow-hidden pt-5 pb-10 sm:pt-10 sm:pb-16 px-4 sm:px-6 lg:px-8" data-id="element-133">
      {/* Subtle decorative blobs */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-pilates-sage/20 rounded-full blur-3xl pointer-events-none" data-id="element-134"></div>
      <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] bg-pilates-lavender/20 rounded-full blur-3xl pointer-events-none" data-id="element-135"></div>

      <div className="relative max-w-3xl mx-auto flex flex-col items-center text-center z-10" data-id="element-136">
        <div className="flex items-center gap-2 mb-2 sm:mb-6" data-id="element-137">
          <Flower2 className="w-4 h-4 sm:w-5 sm:h-5 text-pilates-sage-dark" data-id="element-138" />
          <span className="font-display font-semibold text-pilates-dark text-base sm:text-lg tracking-[0.25em] uppercase" data-id="element-139">
            HOCKEY READY
          </span>
        </div>

        <div className="bg-white/70 backdrop-blur-sm border border-pilates-sage/30 text-pilates-sage-dark font-medium text-[10px] sm:text-sm px-3 sm:px-4 py-1 sm:py-1.5 rounded-full mb-2.5 sm:mb-8 flex items-center gap-2 shadow-sm" data-id="element-140">
          <span data-id="element-141">✨</span> VALIDATED COACHING METHOD
        </div>

        <h1 className="font-display sm:text-5xl md:text-6xl font-medium text-pilates-dark leading-[1.15] sm:leading-[1.05] mb-2.5 sm:mb-6 tracking-tight text-[26px]" data-id="element-142">
          NEVER SPEND HOURS PLANNING HOCKEY SESSIONS AGAIN
        </h1>

        <p className="text-sm sm:text-lg text-pilates-slate max-w-xl mb-3 sm:mb-8 leading-snug sm:leading-relaxed px-2 sm:px-0" data-id="element-143">
          Teach with confidence using a proven planning system built for hockey
          coaches.
        </p>

        <ul className="text-left space-y-1.5 sm:space-y-2.5 mb-4 sm:mb-10 max-w-md mx-auto w-full px-4 sm:px-0" data-id="element-144">
          {benefits.map((item, i) => <li key={i} className="flex items-start gap-2.5 text-pilates-dark font-medium text-[13px] sm:text-base" data-id="element-145">
              <Check className="w-4 h-4 sm:w-5 sm:h-5 text-pilates-sage-dark flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-146" />
              <span data-id="element-147">{item}</span>
            </li>)}
        </ul>

        <div className="mb-3 sm:mb-10 max-w-[240px] sm:max-w-md mx-auto w-full" data-id="element-148">
          <img src="https://cdn.magicpatterns.com/uploads/uEWrvggmqQrXtSH8StzMch/image_(9).webp" alt="Hockey Ready 6-in-1 Box Set" className="w-full rounded-2xl shadow-2xl" fetchPriority="high" decoding="async" width="800" height="800" data-id="element-149" />
        </div>

        <a href="#pricing-card" className="group relative inline-flex items-center justify-center gap-2 sm:gap-3 bg-gradient-to-r from-pilates-rose to-pilates-rose-dark text-white font-semibold text-sm sm:text-lg py-3 sm:py-4 px-6 sm:px-12 rounded-full shadow-[0_10px_30px_rgba(201,123,99,0.35)] hover:shadow-[0_15px_40px_rgba(201,123,99,0.5)] hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto pt-[16px] pb-[16px] sm:pt-[20px] sm:pb-[20px]" data-id="element-150">
          <span data-id="element-151">🚀 YES, I WANT HOCKEY READY NOW</span>
          <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" data-id="element-152" />
        </a>

        <div className="mt-3 sm:mt-6 flex flex-col items-center gap-1.5 sm:gap-2" data-id="element-153">
          <div className="flex items-center gap-2" data-id="element-154">
            <div className="flex text-pilates-rose" data-id="element-155">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="currentColor" data-id="element-156" />)}
            </div>
            <span className="text-pilates-slate text-xs sm:text-sm font-medium" data-id="element-157">
              4.9/5 — Rated by Hockey Coaching Professionals
            </span>
          </div>
          <div className="flex items-center gap-2 text-pilates-slate text-xs sm:text-sm" data-id="element-158">
            <ShieldCheck className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-pilates-sage-dark" data-id="element-159" />
            <span data-id="element-160">7-Day Money-Back Guarantee</span>
          </div>
        </div>
      </div>
    </section>;
}